import * as React from "react";

import { H3, PaddedSurface, Paragraph } from "App/global-style";

import { useTexts } from "Components/TextContext";
import { BankIdLogin } from "../BankIdLogin";
import { useBankIdLoginHandler } from "../bankIdLoginHooks";

export const HouseBankIdLogin = (): React.ReactElement => {
  const { getText } = useTexts();
  const handleBankIdLogin = useBankIdLoginHandler();

  return (
    <PaddedSurface>
      <H3>{getText("houseform.subheader.findyourhouse")}</H3>
      <Paragraph>{getText("houseform.description.findyourhouse")}</Paragraph>

      <BankIdLogin handleLogin={() => handleBankIdLogin()} />
    </PaddedSurface>
  );
};
